import React, { Component } from 'react';
import Profile from './PatientBox.js';
import ProfileSimpleList from './PatientSimpleList.js';
import { Card, Row } from "antd";
import '../components-style.css';
import {FormattedMessage} from 'react-intl';
import Utils from "../Common/Utils.js";
import Pagination from '@mui/material/Pagination';
import DataServiceSQL from '../../DataService/DataServiceSQL';
import DeleteObject from '../Common/DeleteObject.js';
import CopyableId from '../Common/CopyableId.js';
import { userIsSuperAdmin } from '../../Controller/userRoles.js';

class PatientBoxList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            deleteInvalidPatientId: null,
            deletedInvalidIds: []
        }

        this.handlePaginationChange = this.handlePaginationChange.bind(this);
    }

    handlePaginationChange(event, value) {
        this.setState(state => ({
            page: value
        }));
    };

    //Function to get profile corresponding history data
    get_profile_data(local_id_patient, profilesInformation, dateSelected){

        let local_data = profilesInformation.find(ProfileHistoryData => { return ProfileHistoryData.Patient_Data.id_patient === local_id_patient});
        let selectedDateStart = new Date (dateSelected[0]);
        let selectedDateEnd  = new Date (dateSelected[1]);
        local_data.Patient_Data.currentTime = Utils.setCurrentTimePoint(selectedDateEnd);
        local_data.Patient_Data.MaxFeverDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.fever_alert.threshold);
        local_data.Patient_Data.MaxPulseRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.PR_alert.threshold);
        local_data.Patient_Data.MinSpO2Drawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.SPO2_alert.threshold);
        local_data.Patient_Data.MaxPulseRateDrawingTension = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.bloodpressure_PR_alert.threshold);
        local_data.Patient_Data.MaxSystolicDrawingTension = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold);
        local_data.Patient_Data.MaxDiastolicDrawingTension = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.bloodpressure_dia_alert.threshold);
        local_data.Patient_Data.weightThreshold = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.weight_alert.threshold);
        local_data.Patient_Data.MaxPainDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.pain_alert.threshold);
        local_data.Patient_Data.MaxHealthformDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.eq5d_alert.threshold);
        local_data.Patient_Data.MaxHealthscaleDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.eq5d_scale_alert.threshold);
        local_data.Patient_Data.MaxBreathingRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.breathing_rate_alert.threshold);
        local_data.Patient_Data.MaxBreathingOxygenRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.breathing_oxygen_rate_alert.threshold);
        local_data.Patient_Data.MaxBreathingLeakageDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.breathing_leakage_alert.threshold);
        local_data.Patient_Data.MaxBreathingObservanceDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, local_data.Patient_Data.alerts.breathing_observance_alert.threshold);
        return (local_data);
    }

    //Function to generate the list of profiles
    display_profile_list(){
        Utils.sortDataByNames(this.props.profilesInformation)
        let profilesInformationPaginated = []
        let begin = (this.state.page - 1) * 16
        let i = begin
        while (this.props.profilesInformation[i] && i < begin + 16) {
            const p = this.props.profilesInformation[i];
            if (!(p.Patient_Data._invalid && this.state.deletedInvalidIds.includes(p.Patient_Data.id_patient))) {
                profilesInformationPaginated.push(p)
            }
            console.log(i)
            i++;
        }
        if (this.props.extendedView !== "list") {
        return(
            <Row style={{width: "auto"}}>

                    <Row style={{width: "100%"}}>
                        {profilesInformationPaginated.map(profile => {

                    if (profile.Patient_Data._invalid) {
                        return (
                            <div key={profile.Patient_Data.id_patient} style={{margin:"5px", padding:"12px 16px", border:"1px solid #f0a500", borderRadius:"6px", backgroundColor:"#fff9e6", color:"#7a4400", width:"320px", maxHeight:"120px", boxSizing:"border-box", display:"flex", flexDirection:"column", justifyContent:"space-between"}}>
                                <div style={{fontSize:"13px", fontWeight:"bold", marginBottom:"6px"}}>
                                    &#9888; Patient incorrectly created
                                </div>
                                <div style={{fontSize:"11px", wordBreak:"break-all", marginBottom:"10px", color:"#9a5e00"}}>
                                    {userIsSuperAdmin(this.props.accountInformation)
                                        ? <CopyableId value={profile.Patient_Data.id_patient} label="id_patient" />
                                        : <>ID: {profile.Patient_Data.id_patient}</>}
                                </div>
                                <button
                                    onClick={() => this.setState({ deleteInvalidPatientId: profile.Patient_Data.id_patient })}
                                    style={{alignSelf:"flex-start", padding:"3px 10px", fontSize:"11px", backgroundColor:"#c0392b", color:"white", border:"none", borderRadius:"4px", cursor:"pointer"}}
                                >
                                    &#128465; Delete
                                </button>
                            </div>
                        );
                    }
                    const profileData = this.get_profile_data(profile.Patient_Data.id_patient, this.props.profilesInformation, this.props.dateSelected);
                    // For a shared patient, the device/sensor data is governed by the
                    // OWNING structure's subscription, not the viewer's. Use the owner
                    // features carried on the profile when present, else the viewer's.
                    // Exception: patient_add_delete_block (bit 22) is a viewer permission,
                    // not a device-display feature — always use the viewer's own value for it.
                    const ownerFeatures = profileData && profileData.Patient_Data ? profileData.Patient_Data.subscription_features : null;
                    let effectiveSubscriptionInfo;
                    if (ownerFeatures !== undefined && ownerFeatures !== null) {
                        const deleteBlockBit = Utils.featureToBitNumber("patient_add_delete_block");
                        const viewerFeatures = this.props.subscription_info.features;
                        const viewerDeleteBlock = Utils.checkBit(viewerFeatures, deleteBlockBit) ? (1 << deleteBlockBit) : 0;
                        const mergedFeatures = (ownerFeatures & ~(1 << deleteBlockBit)) | viewerDeleteBlock;
                        effectiveSubscriptionInfo = { ...this.props.subscription_info, features: mergedFeatures };
                    } else {
                        effectiveSubscriptionInfo = this.props.subscription_info;
                    }
                    return(
                        <Profile
                        	// individual data for each profile
                            key                       = {profile.Patient_Data.id_patient}
                                profileData               = {profileData}                    // structure containing all profile data

                            // common data for all profiles
                            structure_groups          = {this.props.structure_groups}
                            structure_devices         = {this.props.structure_devices}
                            structure_gateways        = {this.props.structure_gateways}
                            extendedView              = {this.props.extendedView}
                            dateSelected              = {this.props.dateSelected}
                            updateProfileParameters   = {this.props.updateProfileParameters}
                            accountInformation        = {this.props.accountInformation}
                            structure_Id              = {this.props.structure_Id}
                            subscription_info         = {effectiveSubscriptionInfo}
                            viewerSubscriptionFeatures = {this.props.subscription_info.features}
                            reloadUserAndProfiles     = {this.props.reloadUserAndProfiles}
                            userRole                  = {this.props.userRole}
                            select_tooltip            = {this.props.select_tooltip}
                            screenSize                = {this.props.screenSize}
                            intl                      = {this.props.intl}
                            hidePatientIds            = {this.props.hidePatientIds}
                        />
                    )
                })}
            </Row>
                    <Row style={{width:"100%", display:"flex", justifyContent:"center", alignItems:"center"}}>
                        <Pagination sx={{"& .MuiPaginationItem-root": {backgroundColor: "white"}}} variant="outlined" count={Math.ceil(this.props.profilesInformation.length/16)} showFirstButton showLastButton page={this.state.page} onChange={this.handlePaginationChange}/>
                    </Row>
                </Row>
        );
        }
        else {
            return(
                <ProfileSimpleList
                    accountInformation  = {this.props.accountInformation}
                    profilesInformation = {this.props.profilesInformation}
                    screenSize          = {this.props.screenSize}
                    subscription_info   = {this.props.subscription_info}
                    struct_info         = {this.props.struct_info}
                    get_profile_data    = {this.get_profile_data}
                    dateSelected        = {this.props.dateSelected}
                    intl                = {this.props.intl}
                    userRole            = {this.props.userRole}
                    hidePatientIds      = {this.props.hidePatientIds}
                />
            )
        }
    }

    render(){
        const { deleteInvalidPatientId } = this.state;
        if(this.props.profilesInformation.length !== 0){
            return(
                <div>
                    {this.display_profile_list()}
                    {deleteInvalidPatientId &&
                        <DeleteObject
                            cancelPopup={() => this.setState({ deleteInvalidPatientId: null })}
                            closeAfterDelete={() => {
                                this.setState(prev => ({
                                    deleteInvalidPatientId: null,
                                    deletedInvalidIds: [...prev.deletedInvalidIds, deleteInvalidPatientId]
                                }));
                                this.props.reloadUserAndProfiles && this.props.reloadUserAndProfiles();
                            }}
                            object_type={"patient"}
                            patient={{ Patient_Data: { id_patient: deleteInvalidPatientId } }}
                            object_name={deleteInvalidPatientId}
                        />
                    }
                </div>
            );
        }
        else{
            return(
                <Card id="box-no-profile">
                    <FormattedMessage id="profileList.noProfile" defaultMessage="No profile to display"/>
                </Card>
            );
        }


    }
}
export default (PatientBoxList);
